<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-12 ccs-layout--no-pad">
      <ccs-input class="ccs-4" type="text" label="Фамилия"
        v-model.trim="participant.last_name" placeholder="Введите фамилию" />
      <ccs-input class="ccs-4" type="text" label="Имя"
        v-model.trim="participant.first_name" placeholder="Введите имя"/>
      <ccs-input class="ccs-4" type="text" label="Отчество"
        v-model.trim="participant.patronymic" placeholder="Введите отчество"/>
      <ccs-input class="ccs-4" type="autocomplete" label="Роль" :items="rolesForSelect"
        v-model="participant.event_role_id" @change="onRoleSearch"
        placeholder="Начните ввод для поиска"/>
      <ccs-input class="ccs-4" type="text" label="Email"
        v-model.trim="participant.email" placeholder="Введите email"/>
      <ccs-input class="ccs-4" type="text" label="Номер телефона"
        v-model.trim="participant.phone" placeholder="Введите номер телефона"/>
      <ccs-input class="ccs-4" type="text" label="Регион/Компания/ВУЗ"
        v-model.trim="participant.subject" placeholder="Введите название"/>
      <ccs-input class="ccs-8" type="text" label="Образовательная организацния"
        v-model.trim="participant.institution" placeholder="Введите название"/>
      <ccs-input class="ccs-2" type="dropdown" label="Размер одежды" :items="clothSizes"
        v-model.trim="participant.cloth_size" placeholder="Выберите размер"
        :modifiers="['no_cancel']"/>
      <ccs-input class="ccs-2" type="text" label="Тег"
        v-model.trim="participant.label" placeholder="Введите тег"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить изменения
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'Participant',
  mixins: [AutocompleteParent],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      clothSizes: [
        {
          prop: 'XS',
          text: 'XS',
        },
        {
          prop: 'S',
          text: 'S',
        },
        {
          prop: 'M',
          text: 'M',
        },
        {
          prop: 'L',
          text: 'L',
        },
        {
          prop: 'XL',
          text: 'XL',
        },
        {
          prop: 'XXL',
          text: 'XXL',
        },
        {
          prop: 'XXXL',
          text: 'XXXL',
        },
      ],
      rolesForSelect: [],
      participant: {
        event_id: 0,
        event_role_id: undefined,
        skill_id: '',
        first_name: '',
        last_name: '',
        patronymic: '',
        email: '',
        phone: '',
        subject: '',
        institution: '',
        cloth_size: 'XS',
        label: '',
      },
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    ...mapState('events', ['event']),
    ...mapState('skills', ['skill']),
  },
  methods: {
    ...mapActions('users', ['createParticipant', 'updateParticipant']),
    async onRoleSearch(text) {
      [this.rolesForSelect] = await this.getAutocompleteData('/v1/events/roles/list', text);
    },
    async submit() {
      if (this.participant.id) {
        await this.editParticipant();
      } else {
        await this.addParticipant();
      }
    },
    async addParticipant() {
      try {
        this.participant.event_id = Number(this.event.id);
        this.participant.skill_id = Number(this.skill.id);
        let participant = await this.createParticipant(this.participant);
        this.$toasted.success('Участник добавлен!');
        this.$emit('submit', participant);
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async editParticipant() {
      try {
        await this.updateParticipant(this.participant);
        this.$toasted.success('Изменения сохранены');
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  created() {
    if (this.$props.data && this.$props.data.id) {
      this.participant = this.$props.data;
      this.participant.event_role_id = this.$props.data.role.id;
      this.rolesForSelect = [{
        prop: this.$props.data.role.id,
        text: this.$props.data.role.name,
      }];
    }
  },
}
</script>

<style>

</style>